import React, { useEffect, useState } from 'react';
import SectionTitle from '../UI/SectionTitle'
import ServiceItem from  './ServiceItem'
import serviceTopBg from '../../assets/img/service/service-bg.jpg'
import {useHomeServices} from './../../queries/homeServices';
import InfinitProgressBar from '../InfiniteProgressBar';

function Services({classes}) {

    const [HomeServises, setHomeServises] = useState([]);
    const [LoadingHomeServises, LoadingsetHomeServises] = useState(true);

   

    const {error, loading, data} = useHomeServices();
    
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>


    return (
                <div className={`service-area-wrapper ${classes}`}>
                    <div className="service-area-top" style={{backgroundImage: `url("${serviceTopBg}")`}}>
                        <div className="container"  style={{marginBottom: '5%', marginTop: "-5%"}}>
                            <div className="row">
                                <div className="col-lg-6 col-xl-5 m-auto text-center" style={{marginTop:"-5%"}}>
                                    <SectionTitle variant="light" title="" txtcolor="#fff" heading={data.homeServices[0].displayText} />
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div className="service-content-area">
                        <div className="container">
                            <div className="row mtn-30">
                                {
                                    data.homeServices[0].bag.contentItems.map(service=>(
                                        
                                        <ServiceItem key={service.id} id={service.id} title={service.displayText} text={service.serviceOverview.html} thumb={service.serviceImage.urls[0]}/>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
        
    );
}

export default Services;
